exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".return-list[data-v-491235d4]{padding-bottom:10px;display:block;border-bottom:1px solid #ccc;cursor:pointer}.tab-headers button[data-v-491235d4]{width:50%;border:1px solid #ddd;background:#ccc}.active[data-v-491235d4]{background:#eee!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-491235d4","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/CompanyConversation.vue
// module id = Zl4f
// module chunks = 0